<app-breadcrumb [master]="'Analizy'" [parentName]="'Rejestracje'" [name]="'Raporty'"></app-breadcrumb>
<div class="report-registration-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="report-registration-list-filters">
    <ng-container >
      <app-dict-ofwcas
        [multiple]="false"
        label="OFWCA" class="report-registration-list-filter"
        [(ngModel)]="initialFilters.ofwca"
        name="ofwca"
      ></app-dict-ofwcas>

      <app-dict-all-contracts
         [multiple]="false"
        label="Umowa" class="report-registration-list-filter"
        [(ngModel)]="initialFilters.contract"
        name="contract"
      ></app-dict-all-contracts>

      <app-dict-insurance-companies
        (selectedInsuranceCompanies)="selectedInsuranceCompanies = $event"
        [multiple]="true" label="TU" class="report-registration-list-filter"
        [(ngModel)]="initialFilters.in$insuranceCompany"
        name="in$insuranceCompany"
      ></app-dict-insurance-companies>

      <app-dict
        [multiple]="false" [dictType]="'sales_' + (selectedInsuranceCompanies ? selectedInsuranceCompanies[0]?.key : '')"
        [label]="'Nazwa profilu'" class="report-registration-list-filter"
        matTooltip="Najpierw wybierz TU"
        matTooltipPosition="left"
        [matTooltipDisabled]="!!selectedInsuranceCompanies"
        [(ngModel)]="initialFilters.salesProfileType" name="salesProfileType"
      ></app-dict>

      <app-dict
         [multiple]="false"
        label="Rodzaj TU" class="report-registration-list-filter"
        dictType="insurance_type"
        [(ngModel)]="initialFilters.insuranceCompanyType" name="insuranceCompanyType"
      ></app-dict>

      <app-dict
        [multiple]="true"
        label="Status" class="report-registration-list-filter"
        dictType="registration_status"
        [(ngModel)]="initialFilters.in$status" name="in$status"
      ></app-dict>

      <app-dict
        [multiple]="false" [dictType]="'sales_profile_status'"
        [label]="'Status profilu'" class="report-registration-list-filter"
        [(ngModel)]="initialFilters.salesProfileStatus" name="salesProfileStatus"
      ></app-dict>

      <mat-form-field appearance="standard" class="report-registration-list-filter">
        <mat-label>Oświadczenia komplet</mat-label>
        <mat-select [(ngModel)]="initialFilters.statements" name="statements">
          <mat-option [value]="null">Wszyscy</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <app-dict
         [multiple]="false"
        label="Firma" class="report-registration-list-filter"
        dictType="company"
        [(ngModel)]="initialFilters.company" name="company"
      ></app-dict>

      <app-dict-partners
        [multiple]="false" label="Partner"
        class="report-registration-list-filter"
        [(ngModel)]="initialFilters.partner" name="partner"
      ></app-dict-partners>

      <app-dict-regionals
        [multiple]="true" label="Regionalny (majątek)"
        class="report-registration-list-filter"
        [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
      ></app-dict-regionals>

      <app-dict-regionals
        [multiple]="true" label="Regionalny (życie)"
        class="report-registration-list-filter"
        [(ngModel)]="initialFilters.lifeRegional" name="lifeRegional"
      ></app-dict-regionals>

      <app-dict
        label="Podwójna rejestracja"
        class="report-registration-list-filter"
        dictType="double_registration"
        [(ngModel)]="initialFilters.doubleRegistration" name="doubleRegistration"
      ></app-dict>

      <app-dict
         label="Jaki egzamin potrzebny"
        class="report-registration-list-filter"
        dictType="exam_type"
        [(ngModel)]="initialFilters.missingExam" name="missingExam"
      ></app-dict>

      <mat-form-field appearance="standard" class="report-registration-list-filter" >
        <mat-label>Aktywne KRK</mat-label>
        <mat-select
          [(ngModel)]="initialFilters.activeKrk" name="activeKrk"
        >
          <mat-option [value]="null">Wszyscy</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="standard" class="report-registration-list-filter" >
        <mat-label>Zaświadczenie 100p</mat-label>
        <mat-select
          [(ngModel)]="initialFilters.passedExam100p" name="passedExam100p"
        >
          <mat-option [value]="null">Wszyscy</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field  appearance="standard" class="report-registration-list-filter">
        <mat-label>Dyplom</mat-label>
        <mat-select
          [(ngModel)]="initialFilters.hasDiploma" name="hasDiploma"
        >
          <mat-option [value]="null">Wszyscy</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="standard" class="report-registration-list-filter">
        <mat-label>Zgoda na wyrejestrowanie</mat-label>
        <mat-select
          ngModel name="agreedToDeregister"
        >
          <mat-option [value]="null">Wszyscy</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <app-dict
        class="report-registration-list-filter" [label]="'Tagi partnera'"
        [dictType]="'partner_tags'"
        [required]="false" [multiple]="true"
        [(ngModel)]="initialFilters.partnerTags" name="partnerTags"
      ></app-dict>

      <app-dict
        class="report-registration-list-filter" [label]="'Status upoważnienia'"
        [dictType]="'authorization_status'"
        [required]="false" [multiple]="false"
        [(ngModel)]="initialFilters.authorizationStatus" name="authorizationStatus"
      ></app-dict>

      <app-datepicker
        class="report-registration-list-filter"
        label="Data wygenerowania upoważnienia od"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.gte$authorizationGeneratedAt" name="gte$authorizationGeneratedAt"
      ></app-datepicker>

      <app-datepicker
        class="report-registration-list-filter"
        label="Data wygenerowania upoważnienia do"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.lte$authorizationGeneratedAt" name="lte$authorizationGeneratedAt"
      ></app-datepicker>

      <app-datepicker
        class="report-registration-list-filter"
        label="Data dodania wniosku o rejestrację od"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
      ></app-datepicker>

      <app-datepicker
        class="report-registration-list-filter"
        label="Data dodania wniosku o rejestrację do"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
      ></app-datepicker>

      <mat-form-field appearance="standard" class="report-registration-list-filter" >
        <mat-label>Dostęp chronie.pl</mat-label>
        <mat-select [(ngModel)]="initialFilters.chronieAccess" name="chronieAccess">
          <mat-option [value]="null">Wszyscy</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="report-registration-list-filter" >
        <mat-label>Login chronie.pl</mat-label>
        <input matInput placeholder="adres@asf24.pl" name="chronieLogin" [(ngModel)]="initialFilters.chronieLogin">
      </mat-form-field>

      <mat-form-field class="report-registration-list-filter" >
        <mat-label>Kod zniżkowy</mat-label>
        <input matInput placeholder="000001" name="chronieDiscountCode" [(ngModel)]="initialFilters.chronieDiscountCode">
      </mat-form-field>

      <mat-form-field appearance="standard" class="report-registration-list-filter">
        <mat-label>Blokada sprzedaży - Wysłane do TU</mat-label>
        <mat-select [(ngModel)]="initialFilters.sentToBlock" name="sentToBlock">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="standard" class="report-registration-list-filter">
        <mat-label>Blokada sprzedaży - Zablokowane</mat-label>
        <mat-select [(ngModel)]="initialFilters.blocked" name="blocked">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="standard" class="report-registration-list-filter">
        <mat-label>Zgoda na rejestrację w PZU</mat-label>
        <mat-select [(ngModel)]="initialFilters.agreedToRegisterInPzu" name="agreedToRegisterInPzu">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="report-registration-list-filter">
        <mat-label>Numer RAU</mat-label>
        <input matInput placeholder="Numer RAU" name="rauNumber" [(ngModel)]="initialFilters.rauNumber">
      </mat-form-field>

      <app-dict-deregistration-packs
        class="report-registration-list-filter" [label]="'Paczka wyrejestrowań'"
        [required]="false" [multiple]="false"
        [(ngModel)]="initialFilters.deregistrationPack" name="deregistrationPack"
      ></app-dict-deregistration-packs>

      <app-dict
        class="report-registration-list-filter"
        [multiple]="false" [dictType]="'address_state'"
        [label]="'Województwo placówki OFWCA'"
        [(ngModel)]="initialFilters.facilityStateOfwca" name="facilityStateOfwca"
      ></app-dict>
    </ng-container>

  </form>

  <div  fxLayout="row" fxLayoutGap="15px">

    <span fxFlex></span>
    <div fxLayout="row" fxLayoutGap="15px">
      <button *ngIf="(userPermissions | async).analysis.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).analysis.read_report"
              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>

</div>
